import uPlot from 'uplot';

import type { ChartSeries } from '../_shared';

/**
 * 바 차트 전용 패스 빌더
 * align: 0 (중앙 정렬), size: [0.8, 40, 4] (80% 너비, 최대 40px, 최소 4px), radius: 2 (모서리 둥글기)
 */
export const barsPath = uPlot.paths?.bars
  ? uPlot.paths.bars({ align: 0, size: [0.8, 40, 4], radius: 2, gap: 2 })
  : undefined;

/**
 * ChartSeries[] → uPlot.Series[] (바 차트 전용)
 * fill + stroke 동일 색상, 포인트 비활성화
 */
export const convertToUPlotBarSeries = (
  series: ChartSeries[],
  pathBuilder?: uPlot.Series.PathBuilder,
): uPlot.Series[] => {
  const mappedSeries: uPlot.Series[] = series.map((item) => ({
    label: item.label,
    fill: item.color,
    stroke: item.color,
    width: 1,
    points: {
      show: false,
    },
    paths: pathBuilder,
  }));

  return [{}, ...mappedSeries];
};
